module.exports = __webpack_public_path__ + "img/shou_question.fa876b57.png";